import React, { memo, useCallback } from 'react';

import { Box, Typography } from '@mui/material';
import { CopyIcon } from 'app/shared/componentsRestyled/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { COPY_ICON_SIZE } from './MessageTools.constants';
import { copyButtonStyles, getMessageToolsContainerStyles } from './MessageTools.styles';
import { formatTimestamp } from './MessageTools.utils';

const MessageTools = ({ timestamp, onCopy, justifyContent = 'flex-start', className = '', sx }) => {
  const handleCopy = useCallback(() => {
    onCopy();
  }, [onCopy]);

  return (
    <Box className={className} sx={getMessageToolsContainerStyles(justifyContent, sx)}>
      <Box component="button" sx={copyButtonStyles} onClick={handleCopy}>
        <CopyIcon size={COPY_ICON_SIZE} />
        <Typography variant="regular12">Copy</Typography>
      </Box>
      <Typography color="textSecondary" variant="regular12">
        {formatTimestamp(timestamp)}
      </Typography>
    </Box>
  );
};

MessageTools.propTypes = {
  onCopy: PropTypes.func.isRequired,
  timestamp: PropTypes.string,
  justifyContent: PropTypes.oneOf(['flex-start', 'flex-end', 'center', 'space-between']),
  className: PropTypes.string,
  sx: PropTypes.object,
};

export default memo(MessageTools);
